var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _path6, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _path7, _ellipse4, _circle6, _ellipse5, _circle7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#e8782f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#ea8847",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 46C32 22 48 18 60 18S88 22 85 46L90 104H30Z",
    fill: "#3a2a22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#4f7bb0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L58 104L52 94Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87L60 100L74 87L68 85L60 92L52 85Z",
    fill: "#fbfaf5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100L60 124",
    stroke: "#3f628c",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 108,
    r: 1.3,
    fill: "#3f628c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 116,
    r: 1.3,
    fill: "#3f628c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#c1906b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#dca47a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#dca47a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#dca47a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#ab7f5f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#3a2a22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#3a2a22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54C37 80 48 86 60 86S83 80 82 54C80 62 76 66 70 66C66 63 54 63 50 66C44 66 40 62 38 54Z",
    fill: "#3a2a22",
    opacity: 0.22
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52C33 30 50 21 62 22C76 23 85 33 82 52C79 42 74 38 68 36C60 44 48 40 42 46C40 48 39 50 38 52Z",
    fill: "#3a2a22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait13);
export default __webpack_public_path__ + "static/media/player-portrait-13.faa457df93034a74579dcff8b2c2d00f.svg";
export { ForwardRef as ReactComponent };